import createDataSlice from '€lib/reducers/createDataSlice';
import { FormEntryEntity } from '€slices/entity-types';

const slice = createDataSlice<FormEntryEntity>({
    name: 'formEntry',
    reducers: {
        upsert: (state, { payload: { id, data } }) => ({
            ...state,
            byId: {
                ...state.byId,
                [id]: {
                    ...state.byId[id],
                    ...data,
                },
            },
        }),
        setValue: (state, { payload: { id, name, value } }) => ({
            ...state,
            byId: {
                ...state.byId,
                [id]: {
                    ...state.byId[id],
                    [name]: value,
                },
            },
        }),
    },
});

export const { actions, name, reducer, selectors } = slice;
export const { requestData, receiveDataSuccess, receiveDataFailure, upsert, setValue } = actions;
export default slice;
